export const getListOfUsers = {
  GET_LIST_OF_USERS_REQUEST: "GET_LIST_OF_USERS_REQUEST",
  GET_LIST_OF_USERS_SUCCESS: "GET_LIST_OF_USERS_SUCCESS",
  GET_LIST_OF_USERS_ERROR: "GET_LIST_OF_ACCOUNTS_ERROR",
};
